let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lQwQZ")).then(() => parcelRequire('aMdh8'));